'use client'

import { errorIcon, successIcon } from '../constant'
import { EventEmit, eventEmitter, ToastType } from '../utils'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'

interface Props {
  transform?: number
  className?: string
}

export function Toast({ transform = 0, className }: Props) {
  const [key, setKey] = useState(0)
  const [toast, setToast] = useState<{
    message: string
    type: ToastType
  } | null>(null)
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const handleShowToast = ({ message, type }: { message: string; type: ToastType }) => {
      if (toast) {
        setKey((prevState) => prevState + 1)
      }
      setToast({ message, type })

      if (timeoutId) clearTimeout(timeoutId)

      const newTimeoutId = setTimeout(() => {
        setToast(null)
      }, 5000)

      setTimeoutId(newTimeoutId)
    }

    eventEmitter.on(EventEmit.Toast, handleShowToast)

    return () => {
      eventEmitter.off(EventEmit.Toast, handleShowToast)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [timeoutId])

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, x: transform }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: transform }}
          className={`flex-x-center w-full justify-center bg-black ${className}`}
        >
          <motion.div
            key={key}
            className="inline-flex items-center gap-x-6"
            initial={{
              zoom: 0.9,
              opacity: 0.9,
            }}
            animate={{
              zoom: 1,
              opacity: 1,
            }}
            transition={{ duration: 0.1 }}
          >
            {toast.type === ToastType.Success ? successIcon : errorIcon}
            <span>{toast.message}</span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
